<div *ngFor="let item of listNotifications">
    <div class="single_notification" [ngClass]="{
      information: item.type === 1,
      success: item.type === 2,
      warning: item.type === 3,
      critical: item.type === 4
    }">
        <div class="single_notification__row">
            <figure class="single_notification__icon">
                <span [ngSwitch]="item.type">
                    <i *ngSwitchCase="1" class="fas fa-info-circle"></i>
                    <i *ngSwitchCase="2" class="fas fa-check-circle"></i>
                    <i *ngSwitchCase="3" class="fas fa-exclamation-triangle"></i>
                    <i *ngSwitchDefault class="fas fa-exclamation-circle"></i>
                </span>
            </figure>
            <div class="single_notification__content">
                <h4>{{ item.sentBy }}</h4>
                <small>{{ item.date }}</small>
                <p>{{ item.message }}</p>
            </div>
        </div>
    </div>
</div>